import {
  Delete,
  Get,
  Post,
  PostFormData,
  Put,
  getAPIUrl,
} from "../../../services/apiMethod";
import { PropertiesEndpoint } from "./PropertiesEndpoints";

export const getProperties = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.getProperties, param);
  return Get(url);
};
export const getPropertyTypeDetails = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.getPropertyTypeDetails, param);
  return Get(url);
};
export const getPropertiesbyId = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.getPropertiesbyId, param);
  return Get(url);
};
export const modifyStatus = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.modifyStatus, param);
  return Get(url);
};
export const addProperty = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.addProperty, param);
  return PostFormData(url, data, true);
};
export const editProperty = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.editProperty, param);
  return Post(url, data, true);
};
export const addPlot = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.addPlot, param);
  return PostFormData(url, data, true);
};
export const editPlot = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.editPlot, param);
  return Post(url, data, true);
};
export const deleteProperty = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.deleteProperty, param);
  return Delete(url, param);
};
export const deleteImageAPI = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.deleteImageAPI, param);
  return Delete(url, param);
};
export const uploadImageAPI = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.uploadImageAPI, param);
  return PostFormData(url, data, true);
};
export const uploadfloorPlanImageAPI = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.uploadfloorPlanImageAPI, param);
  return PostFormData(url, data, true);
};
export const uploadThumbnailAPI = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.uploadThumbnailAPI, param);
  return Post(url);
};

export const getPropertTypeUpdate = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.getPropertTypeUpdate, param);
  return Post(url, data);
};
//Property Type APi Function

export const deletePropertyType = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.deletePropertyType, param);
  return Post(url, data, true);
};
export const addPropertyType = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.addPropertyType, param);
  return Post(url, data, true);
};
export const updatePropertyType = (data, param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.updatePropertyType, param);
  return Post(url, data, true);
};
export const getPropertyType = (param = "") => {
  const url = getAPIUrl(PropertiesEndpoint.getPropertyType, param);
  return Get(url, true);
};
